<template>
    <div id="logs_archive_history_page" class="container-fluid">
        <h4 class="margin-left10">Client: {{ client.name }}</h4>

        <div class="modal fade" id="view_archive_history" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-xxl" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title text-center w-100">{{ selected_change.date }}<b v-if="previous_change.date" class="margin-x5">VS</b>{{ previous_change.date }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <div class="row">
                            <div class="col-6 selected-change">
                                <div class="archive-data">
                                    <div v-if="change" v-for="(change, key) in selected_change.data" class="margin-top15" :class="compareSide1(change, key)">
                                        <span class="badge badge-secondary">{{ key }}</span>
                                        <span class="badge badge-success">New / Updated</span>
                                        <p v-html="change"></p>
                                    </div>
                                </div>
                            </div>

                            <div class="col-6">
                                <div class="archive-data">
                                    <div v-if="change" v-for="(change, key) in previous_change.data" class="margin-top15" :class="compareSide2(change, key)">
                                        <span class="badge badge-secondary">{{ key }}</span>
                                        <span class="badge badge-success">New / Updated</span>
                                        <p v-html="change"></p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ul class="nav nav-tabs nav-fill" id="view_archive_history_nav" role="tablist">
            <li class="nav-item" role="presentation">
                <a class="nav-link active" id="report_highlights_tab" data-toggle="tab" href="#report_highlights" role="tab" aria-controls="report_highlights" aria-selected="true">REPORT HIGHLIGHTS</a>
            </li>

            <li class="nav-item" role="presentation">
                <a class="nav-link" id="social_key_takeaways_tab" data-toggle="tab" href="#social_key_takeaways" role="tab" aria-controls="social_key_takeaways" aria-selected="false">SOCIAL KEY TAKEAWAYS</a>
            </li>

            <li class="nav-item" role="presentation">
                <a class="nav-link" id="updates_insights_tab" data-toggle="tab" href="#updates_insights" role="tab" aria-controls="updates_insights" aria-selected="false">UPDATES & INSIGHTS</a>
            </li>
        </ul>

        <div class="tab-content padding-top20" id="view_archive_history_nav_content">
            <div class="tab-pane fade show active" id="report_highlights" role="tabpanel" aria-labelledby="report_highlights_tab">
                <v-client-table :data="report_highlights_table_data" :columns="columns" :options="options">
                    <div slot="actions" slot-scope="props" class="text-right">
                        <button @click="viewReportHighlightsChange(props.row.id, props.row.archive_id)" type="button" class="btn btn-info reverse">View</button>
                    </div>
                </v-client-table>
            </div>

            <div class="tab-pane fade" id="social_key_takeaways" role="tabpanel" aria-labelledby="social_key_takeaways_tab">
                <v-client-table :data="social_key_takeaways_table_data" :columns="columns" :options="options">
                    <div slot="actions" slot-scope="props" class="text-right">
                        <button @click="viewSocialKeyTakeawaysChange(props.row.id, props.row.archive_id)" type="button" class="btn btn-info reverse">View</button>
                    </div>
                </v-client-table>
            </div>

            <div class="tab-pane fade" id="updates_insights" role="tabpanel" aria-labelledby="updates_insights_tab">
                <v-client-table :data="updates_insights_table_data" :columns="columns" :options="options">
                    <div slot="actions" slot-scope="props" class="text-right">
                        <button @click="viewUpdatesAndInsightsChange(props.row.id, props.row.archive_id)" type="button" class="btn btn-info reverse">View</button>
                    </div>
                </v-client-table>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        created() {
            this.fetchServerData();
        },

        data() {
            return {
                client:          {},
                selected_change: {},
                previous_change: {},

                columns:                         ['archive_name', 'date_range', 'changed_by', 'date', 'actions'],
                report_highlights_table_data:    [],
                social_key_takeaways_table_data: [],
                updates_insights_table_data:     [],

                options: {
                    headings: {
                        archive_name: 'Archive Name',
                        date_range:   'Date Range',
                        changed_by:   'Changed By',
                        date:         'Date of Change',
                        actions:      ''
                    },
                    sortable: ['archive_name', 'changed_by', 'date'],

                    perPage: 20,
                    perPageValues: [],
                    texts: {
                        count: 'Showing {from} to {to} of {count} logs|{count} logs|One log',
                        filter: '',
                        filterPlaceholder: 'Search logs...',
                        noResults: 'No matching logs'
                    },
                    skin: 'table'
                }
            }
        },

        methods: {
            fetchServerData() {
                axios.all([
                    axios.get(`/api/clients/${this.$route.params.id}`),
                    axios.get(`/api/logs/report-highlights-changes/client/${this.$route.params.id}`),
                    axios.get(`/api/logs/social-key-takeaways-changes/client/${this.$route.params.id}`),
                    axios.get(`/api/logs/updates-and-insights-changes/client/${this.$route.params.id}`)
                ])
                .then(axios.spread((client, reportHighlightsLogs, socialKeyTakeawaysLogs, updatesAndInsightsLogs) => {
                    this.client = client.data;

                    // Adding IDs to be able to locate to next change.
                    _.each(reportHighlightsLogs.data, row => {
                        row.id = parseInt(_.uniqueId());
                    });

                    // Adding IDs to be able to locate to next change.
                    _.each(socialKeyTakeawaysLogs.data, row => {
                        row.id = parseInt(_.uniqueId());
                    });

                    // Adding IDs to be able to locate to next change.
                    _.each(updatesAndInsightsLogs.data, row => {
                        row.id = parseInt(_.uniqueId());
                    });

                    this.report_highlights_table_data    = reportHighlightsLogs.data;
                    this.social_key_takeaways_table_data = socialKeyTakeawaysLogs.data;
                    this.updates_insights_table_data     = updatesAndInsightsLogs.data;
                }));
            },

            viewReportHighlightsChange(id, archiveId) {
                $('#view_archive_history').modal('show');

                this.selected_change = {};
                this.previous_change = {};

                const archiveChanges = _.filter(this.report_highlights_table_data, {archive_id: archiveId});
                const index          = _.findIndex(archiveChanges, {id: id});

                if (index > -1) {
                    this.selected_change = archiveChanges[index];
                    this.previous_change = archiveChanges[index + 1] || {};
                }
            },

            viewSocialKeyTakeawaysChange(id, archiveId) {
                $('#view_archive_history').modal('show');

                this.selected_change = {};
                this.previous_change = {};

                const archiveChanges = _.filter(this.social_key_takeaways_table_data, {archive_id: archiveId});
                const index          = _.findIndex(archiveChanges, {id: id});

                if (index > -1) {
                    this.selected_change = archiveChanges[index];
                    this.previous_change = archiveChanges[index + 1] || {};
                }
            },

            viewUpdatesAndInsightsChange(id, archiveId) {
                $('#view_archive_history').modal('show');

                this.selected_change = {};
                this.previous_change = {};

                const archiveChanges = _.filter(this.updates_insights_table_data, {archive_id: archiveId});
                const index          = _.findIndex(archiveChanges, {id: id});

                if (index > -1) {
                    this.selected_change = archiveChanges[index];
                    this.previous_change = archiveChanges[index + 1] || {};
                }
            },

            compareSide1(change, index) {
                if (this.previous_change.data) {
                    if (!_.isEqual(change, this.previous_change.data[index])) {
                        return 'updated-or-new';
                    }
                }
            },

            compareSide2(change, index) {
                if (this.selected_change.data) {
                    if (!_.isEqual(change, this.selected_change.data[index])) {
                        return 'updated-or-new';
                    }
                }
            }
        }
    }
</script>

<style lang="scss">
    #logs_archive_history_page {
        .modal-header {
            position: relative;

            button {
                position: absolute;
                right: 2rem;
            }
        }

        .modal-body {
            .selected-change {
                border-right: .2rem dashed #cccccc;
            }
        }

        .nav-tabs {
            a.nav-link {
                font-weight: 500;
                font-size: 1.4rem;
                color: #37a8cd;
                background-color: #ffffff;
                border-color: #e9ecef #e9ecef #dee2e6;

                &.active {
                    box-shadow: 0 -0.2rem .3rem #eeeeee;
                    background-color: transparent;
                    color: #37a8cd;
                    border-bottom-color: #f8fafc;
                }
            }
        }

        .archive-data {
            .badge {
                display: none;
                padding: .5rem .5rem .3rem;
            }

            .badge-secondary {
                display: block;
                position: absolute;
                top: -0.9rem;
                left: 1%;
            }

            > div.updated-or-new .badge-success {
                display: block;
                position: absolute;
                top: -0.9rem;
                left: 44%;
                color: white;
            }

            > div {
                background-color: white;
                padding: 1.5rem;
                border: .1rem solid #73b9cf;
                margin-bottom: 1rem;
                position: relative;

                &.updated-or-new {
                    border: .2rem dashed #a6cf71;
                }

                p ul {
                    padding-left: 2rem;
                }
            }
        }
    }
</style>
